import { render, staticRenderFns } from "./cl-mailchimp.vue?vue&type=template&id=445be54c&scoped=true&"
import script from "./cl-mailchimp.vue?vue&type=script&lang=ts&"
export * from "./cl-mailchimp.vue?vue&type=script&lang=ts&"
import style0 from "./cl-mailchimp.vue?vue&type=style&index=0&id=445be54c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445be54c",
  null
  
)

export default component.exports